export default __webpack_public_path__ + "static/decouverte-ddd5729c7c9253df0cce0b868617dde9.png";